import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const subCategoryApi = createApi({
  reducerPath: "subCategoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: GetUrl.API_URL,
  }),
  endpoints: (builder) => ({
    CreateSubCategoryPost: builder.mutation({
      query: (data) => ({
        url: "/admin/create-sub-category",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetSubCategory: builder.query({
      query: () => ({
        url: "/admin/get-all-sub-category",
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetSingleSubCategory: builder.query({
      query: (id) => ({
        url: `/admin/get-single-sub-category/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    EditSubCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/edit-sub-category/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteSubCategory: builder.mutation({
      query: (id) => ({
        url: `/admin/delete-sub-category/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateSubCategoryPostMutation,
  useGetSubCategoryQuery,
  useGetSingleSubCategoryQuery,
  useEditSubCategoryMutation,
  useDeleteSubCategoryMutation,
} = subCategoryApi;
